<template>
  <v-card class="rounded-lg white  pb-8" flat>
    <v-card-title class="secondary--text">
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="received-cheque-chart"></chart-export-btn>
    </v-card-title>
    <div
        class="secondary--text font-weight-bold"
        style="width: 100%; height: 50px; position: absolute; top: 50%; margin-top: auto;
         line-height:19px; text-align: center; z-index: 999999999999999">
      {{title}}
      <br/>
      <span style="margin-top: 25px;" class="grey--text text--darken-2 font-weight-thin" v-if="chartResult">
        جمع کل چک ها :
        {{chartResult.sum}}
      </span>

    </div>
    <canvas id="received-cheque-chart">

    </canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import PaidChequeData from "@/views/modulePages/treasuryModule/paid-cheque-data";
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'ReceivedChequeChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "doughnut",
        data: {
          labels: ["پاس شده","سررسید نشده", "سررسید گذشته", "برگشتی", "در جریان وصول"],
          datasets: [
            {
              data: [],
              backgroundColor: ["#43CED7", "#50CC89", "#FFC700", "#F1416C", '#7239E9'],
              borderWidth: 3,
              hoverBorderWidth:5,
              hoverBorderColor: '#FFFFFF',
            },
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          legend: {
            position: 'bottom'
          },
          cutoutPercentage: 70,
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
          }
        }
      },
      chartResult: null,
    }
  },
  mounted() {
    this.getChartFromApi()

  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/chequesChartApi?is_paid=false`),
        method: "get",
        success: data => {
          this.chartResult = data
          this.getData(data)
        }
      })
    },
    getData(data) {
      this.chartData.options.title.text = 'چک های دریافتنی ' + 'شرکت ' + this.company.name + '  سال مالی ' +
          this.financialYear.name
      this.chartData.options.title.fontSize =  this.titleSize

      this.chartData.data.datasets[0].data = []
      this.chartData.data.datasets[0].data.push(data['passed'])
      this.chartData.data.datasets[0].data.push(data['past_due'])
      this.chartData.data.datasets[0].data.push(data['not_due'])
      this.chartData.data.datasets[0].data.push(data['bounced'])
      this.chartData.data.datasets[0].data.push(data['in_flow'])

      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('received-cheque-chart');
      new Chart(ctx, this.chartData);
    }

  },
  computed: {
    title(){
      return 'چک های دریافتنی'
    },
    titleSize() {
      if (this.main) {
        return 18
      } else {
        return 13
      }
    },
  },

}
</script>